import { Component, Input, OnInit } from '@angular/core';
import { NavigationExtras, Router } from '@angular/router';
import { MenuController, ModalController } from '@ionic/angular';
import { ConfirmModalCartComponent } from 'src/app/components/confirm-modal-cart/confirm-modal-cart.component';
import { ShoppingCart } from 'src/app/models/cart.model';
import { Finishing } from 'src/app/shared-lib/core/settings';
import { PrintFileStatus, ProductService } from 'src/app/shared-lib/domains/product';
import { CartService } from 'src/app/shared/cart.service';
import { FileService } from 'src/app/shared/file.service';
import { UtilsService } from "../../shared/services/utils.service";

@Component({
  selector: 'app-item-print-product',
  templateUrl: './item-print-product.component.html',
  styleUrls: ['./item-print-product.component.scss'],
  standalone: false
})
export class ItemPrintProductComponent implements OnInit {

  @Input() item: ShoppingCart.OrderItem;
  @Input() i;
  @Input() disableActions;
  @Input() showQty;

  viewDetails: boolean = false;
  productWithoutStock: boolean;
  isGroup: boolean;
  _printFileStatus = PrintFileStatus;
  finishing = Finishing;

  withoutStock: { [fileId: string]: { ringColor: boolean, hardCoverFront: boolean, hardCoverBack: boolean; }; } = {};
  bindingStockExceeded;

  coverSettings;

  constructor(
    public cartService: CartService,
    private router: Router,
    private menuCtrl: MenuController,
    private productService: ProductService,
    private modalController: ModalController,
    public fileService: FileService,
    public utils: UtilsService
  ) {
  }

  ngOnInit() {
    this.coverSettings = this.fileService.getCoverSettings();
  }


  async onDelete(item) {
    const modal = await this.modalController.create({
      component: ConfirmModalCartComponent,
      cssClass: "auto-height delete-folder-modal",
      backdropDismiss: false,
      componentProps: {
        folderName: this.getFolderName(this.item, this.i),
        item: this.item,
        deleteModal: true
      },
    });
    modal.present();
  }

  onQtyChange(event) {
    this.item.qty = Math.min(9999, Math.max(1, event.qty));
    this.productService.setPrintProduct(this.item, this.item.product.printingGroup.files);
    this.cartService.refreshCartPrice();
    this.cartService.setCartBindingUses();
  }

  formatProperties(props: object) {
    const properties = [];
    this.item.product.optionsValue.forEach(opt => {
      const prop = Object.entries(props).find(([k, v]) => v === opt);
      if (prop) {
        properties.push({
          key: prop[0],
          value: prop[1],
        });
      }
    });
    return properties;
  }

  toggleViewDetails() {
    this.viewDetails = !this.viewDetails;
  }

  editPrintProduct(item) {
    if (this.router.url === '/') {
      this.cartService.setActivePrintItem(item);
    } else {
      const navigationExtras: NavigationExtras = { state: { item } };
      this.router.navigate(["/"], navigationExtras);
    }
    // Close side menu after navigating to home page
    this.menuCtrl.close('cart-preview');
  }

  getFolderName(item, i) {
    return item.product.folderName ?? `Grupo #${i + 1}`;
  }

  getCoverTypeSetting(file) {
    let setting = this.coverSettings.find(setting => setting.value.id === file.coverType.id);
    return setting;
  }

  updateProductWithoutStock() {
    this.productWithoutStock = Object.values(this.withoutStock).some(
      (file) => file.ringColor || file.hardCoverFront || file.hardCoverBack
    );
    this.viewDetails = this.productWithoutStock;

  }

  bindingOptionValue(file, option, param) {
    let ret;
    let isGroup = this.item.product.printingGroup.printSettings.grouped;
    switch (option) {
      case 'ringColor':
        if (param === 'id')
          ret = (isGroup ? this.item.product.printingGroup.printSettings.ringColor : file.ringColor)?.id;
        if (param === 'name')
          ret = (isGroup ? this.item.product.printingGroup.printSettings.ringColor : file.ringColor)?.name;
        break;
      case 'hardCoverFront':
        if (param === 'id')
          ret = (isGroup ? this.item.product.printingGroup.printSettings.hardCoverFront : file.hardCoverFront)?.id;
        if (param === 'name')
          ret = (isGroup ? this.item.product.printingGroup.printSettings.hardCoverFront : file.hardCoverFront)?.name;
        if (param === 'color')
          ret = (isGroup ? this.item.product.printingGroup.printSettings.hardCoverFront : file.hardCoverFront)?.color;
        break;
      case 'hardCoverBack':
        if (param === 'id')
          ret = (isGroup ? this.item.product.printingGroup.printSettings.hardCoverBack : file.hardCoverBack)?.id;
        if (param === 'name')
          ret = (isGroup ? this.item.product.printingGroup.printSettings.hardCoverBack : file.hardCoverBack)?.name;
        if (param === 'color')
          ret = (isGroup ? this.item.product.printingGroup.printSettings.hardCoverBack : file.hardCoverBack)?.color;
        break;
    }

    return ret;
  }


}
